/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Edit: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="edit" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M902.105 1144.3975C946.3475 1188.6399999999999 1018.13 1188.6399999999999 1062.3725 1144.3975L1144.3975 1062.3725C1188.64 1018.13 1188.64 946.3475 1144.3975 902.105L1054.5525 812.2599999999999L812.2599999999999 1054.5949999999998L902.105 1144.4399999999998zM1008.95 1090.975C994.2024999999998 1105.7224999999999 970.275 1105.7224999999999 955.5275 1090.975L919.105 1054.5525L1054.5525 919.105L1090.975 955.5275C1105.7225 970.2749999999997 1105.7225 994.2024999999998 1090.975 1008.95L1008.95 1090.975zM758.795 1001.1299999999998L1001.0875 758.795L431.1625 188.8699999999999H188.8275V431.1625L758.7525 1001.0875zM264.435 399.8825V264.435H399.8825000000001L894.2425000000001 758.7949999999998L758.795 894.2424999999998L264.435 399.8825z" : "M721.684 915.518C757.078 950.912 814.504 950.912 849.898 915.518L915.518 849.898C950.912 814.5039999999999 950.912 757.078 915.518 721.684L843.6419999999999 649.808L649.808 843.6759999999999L721.684 915.552zM807.16 872.78C795.3619999999999 884.578 776.2199999999999 884.578 764.4219999999999 872.78L735.2839999999999 843.642L843.6419999999999 735.284L872.78 764.422C884.578 776.2199999999999 884.578 795.362 872.78 807.16L807.16 872.78zM607.036 800.904L800.87 607.036L344.93 151.096H151.062V344.93L607.0020000000001 800.87zM211.548 319.906V211.5479999999999H319.906L715.394 607.0359999999998L607.036 715.3939999999999L211.548 319.906z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Edit.displayName = `Blueprint5.Icon.Edit`;
export default Edit;
